import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import {
  ConverterService,
  SearchConfig,
  StateWithProcess,
  UserIdService
} from '@spartacus/core';
import { StateWithOrganization } from '@spartacus/organization/administration/core';
import { getUigAccessSubjectOverview } from '../../store/uig-access-subject/uig-access-subject.action';
import { selectUigAccessSubjectOverview } from '../../store/uig-access-subject/uig-access-subject.selector';
import { AccessSubjectList } from '../../store/uig-access-subject/uig-access-subject.model';

@Injectable({
  providedIn: 'root'
})
export class UigAccessSubjectService {

  constructor(
    protected store: Store<StateWithOrganization | StateWithProcess<void>>,
    protected converter: ConverterService,
    protected userIdService: UserIdService
  ) { }

  loadAccessSubjectOverview(params?: SearchConfig): Observable<AccessSubjectList> {
    this.store.dispatch(getUigAccessSubjectOverview({ params }));

    return this.store.select(selectUigAccessSubjectOverview).pipe(
      filter((data) => data != null),
    );
  }
}
